import * as chat from '../../service/aimsChat';
const initialState = {
disconnectreasons: null,
disconnectdates:null,
etfvalue : false,
ID: "",
postdisconnectreason: "",
Reason: 'select a reason',
reservedisconnectdates:'',
returnequiplist: '',
returnequipoptions: null,
storedetailslist: null,
postreturnoption: "",
contactinfo:{},
UPDATE_CONTACTINFO_RESPONSE:{},
submitorderresponse: null ,
socresponse: null ,
postsocresponse: null,
returnEquipmentCrp:null,
vzstoredetailslist:null, 
retentionOfferResponse: null, 
}

function disconnectvalues(state = initialState, action) {
    switch (action.type) {
            case 'DISCONNECT_REASONS':

            return Object.assign({}, state, {
                disconnectreasons: action.value,
            })
            case 'DISCONNECT_DATE':
                return Object.assign({}, state, {
                    disconnectdates: action.value,
                })
            case 'RESERVE_DISCONNECT_DATES':
                 return Object.assign({}, state, {
                    reservedisconnectdates: action.value,
                    })
                
            case 'ETF_ENABLED':
                    return Object.assign({}, state, {
                        etfvalue: action.value,
                    })
            case 'VALIDATE_INPUT':
                return Object.assign({}, state, {
                    Reason: action.value.REASON !== undefined &&
                    action.value.REASON !== state.Reason ? action.value.REASON: state.Reason,
                    ID: action.value.ID !== undefined &&
                    action.value.ID !== state.ID ? action.value.ID: state.ID,           
                })
            case 'POST_DISCONNECT_REASON': 
                return Object.assign({}, state, {
                    postdisconnectreason: action.value
                }) 
            case 'RETURN_EQUIP_LIST': 
                return Object.assign({}, state, {
                    returnequiplist: action.value                    
                })
            case 'GET_RETURN_OPTIONS': 
                return Object.assign({}, state, {
                    returnequipoptions: action.value
                })
            case 'STORE_DETAILS': 
                return Object.assign({}, state, {
                    storedetailslist: action.value
                })
            case 'VZ_STORE_DETAILS': 
                return Object.assign({}, state, {
                    vzstoredetailslist: action.value
                })
            // case 'SET_RETURN_OPTION':
            //         return Object.assign({}, state, {
            //             returnoptionid: action.value.optionid !== undefined &&
            //             action.value.optionid !== state.returnoptionid ? action.value.optionid: state.returnoptionid ,
            //             returnoptiondesc: action.value.optiondesc !== undefined &&
            //             action.value.optiondesc !== state.returnoptiondesc ? action.value.optiondesc: state.returnoptiondesc         
            //         })                    
            case 'POST_RETURN_OPTION':
                return Object.assign({}, state, {
                    postreturnoption: action.value         
                })
            case 'CONTACT_INFO': 
            return Object.assign({}, state, {
                contactinfo: action.value         
            })
            case "UPDATE_CONTACTINFO_RESPONSE":
            return Object.assign({}, state, {
                UPDATE_CONTACTINFO_RESPONSE: action.value         
            })

            case 'GET_SOC_RESPONSE':
                return Object.assign({}, state, {
                    socresponse: action.value
            })
            
            case 'POST_SOC_RESPONSE':
                return Object.assign({}, state, {
                    postsocresponse: action.value
            })

            case 'SUBMIT_ORDER_RESPONSE':
                return Object.assign({}, state, {
                    submitorderresponse: action.value
            })
            case 'RETURN_EQUIPMENT_CRP':
                return{
                    ...state,
                    returnEquipmentCrp:action.value
                }
            case 'RETENTION_OFFER_RESPONSE':
                return Object.assign({}, state, {
                    retentionOfferResponse: action.value
            })
        
        default:
            return state
    }
}


export default disconnectvalues